// @ts-strict-ignore
import type { Module } from 'vuex'
import type { ContextState, ContextToolState } from '../../models'
import { getDefaultEndpointId } from '../../composables/use-endpoints'
import { FeatureIdEnum, FilterIdEnum } from '../../enums'
import { ResetAction } from '../common/actions/reset.action'
import { ResetMutation } from '../common/mutations/reset.mutation'
import { ClearFiltersAction } from './actions/clear-filters.action'
import { SetContextAction } from './actions/set-context.action'
import { SetEndpointIdAction } from './actions/set-endpoint-id.action'
import { SetFiltersSelectedValuesAction } from './actions/set-filters-selected-values.action'
import { SetQueryAction } from './actions/set-query.action'
import { SetStrictMatchingAction } from './actions/set-strict-matching.action'
import { CONTEXT_CONSTS } from './context.consts'
import { AppliedFiltersCountGetter } from './getters/applied-filters-count.getter'
import { ContextGetter } from './getters/context.getter'
import { CurrentFeatureContextGetter } from './getters/current-feature-context.getter'
import { EnabledFiltersGetter } from './getters/enabled-filters.getter'
import { FiltersAreValidGetter } from './getters/filters-are-valid.getter'
import { SetContextMutation } from './mutations/set-context.mutation'

export const CONTEXT_MODULE: Module<ContextState, any> = {
  namespaced: true,

  initialState: (): ContextState => {
    const baseInitialState = {
      query: undefined,
      strictMatching: undefined,
      endpointId: getDefaultEndpointId(),
    }

    const initialToolState: ContextToolState = {
      ...baseInitialState,
      selectedFiltersValues: {},
    }

    return {
      ...baseInitialState,
      currentFeature: undefined,
      instanceId: undefined,
      domain: undefined,
      filters: {},
      tools: structuredClone(initialToolState),
      [FeatureIdEnum.EXPLAIN]: structuredClone(initialToolState),
      [FeatureIdEnum.INSIGHTS]: structuredClone(initialToolState),
      [FeatureIdEnum.AUDIT]: {
        ...structuredClone(initialToolState),
        selectedFiltersValues: { [FilterIdEnum.DATE]: [undefined, undefined] },
      },
    }
  },
  state: (): ContextState => CONTEXT_MODULE.initialState(),

  getters: {
    [CONTEXT_CONSTS.getters.context]: CurrentFeatureContextGetter.execute,
    [CONTEXT_CONSTS.getters.baseContext]: ContextGetter.execute,
    [CONTEXT_CONSTS.getters.enabledFilters]: EnabledFiltersGetter.execute,
    [CONTEXT_CONSTS.getters.appliedFiltersCount]: AppliedFiltersCountGetter.execute,
    [CONTEXT_CONSTS.getters.filtersAreValid]: FiltersAreValidGetter.execute,
  },

  actions: {
    [CONTEXT_CONSTS.actions.setContext]: SetContextAction.execute,

    [CONTEXT_CONSTS.actions.setFiltersSelectedValues]: SetFiltersSelectedValuesAction.execute,
    [CONTEXT_CONSTS.actions.clearFilters]: ClearFiltersAction.execute,
    [CONTEXT_CONSTS.actions.setQuery]: SetQueryAction.execute,
    [CONTEXT_CONSTS.actions.setStrictMatching]: SetStrictMatchingAction.execute,
    [CONTEXT_CONSTS.actions.setEndpointId]: SetEndpointIdAction.execute,

    [CONTEXT_CONSTS.actions.reset]: context =>
      ResetAction.execute(context, CONTEXT_MODULE.initialState()),
  },

  mutations: {
    [CONTEXT_CONSTS.mutations.setContext]: SetContextMutation.execute,

    [CONTEXT_CONSTS.mutations.reset]: ResetMutation.execute,
  },
}
